<template>
    <i18n path="customerService.text"
          tag="p"
          class="card-text text-secondary">
        <CustomerServiceEmail/>
        <CustomerServicePhone/>
    </i18n>
</template>

<script>
    import CustomerServiceEmail from "./CustomerServiceEmail";
    import CustomerServicePhone from "./CustomerServicePhone";

    export default {
        name: 'CustomerServiceBlock',
        components: {
            CustomerServicePhone,
            CustomerServiceEmail
        }
    }
</script>

<style lang="scss">
</style>
